<template>
  <a
    :href="resumePath"
    download="CV_REYNALDI_SIREGAR.pdf"
    class="resume-button group"
    aria-label="Download my CV"
  >
    <span class="icon-wrap">
      <svg 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 24 24" 
        fill="currentColor" 
        class="icon"
        aria-hidden="true"
      >
        <path 
          fill-rule="evenodd" 
          d="M5.625 1.5H9a3.75 3.75 0 013.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 013.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 01-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875zm5.845 17.03a.75.75 0 001.06 0l3-3a.75.75 0 10-1.06-1.06l-1.72 1.72V12a.75.75 0 00-1.5 0v4.19l-1.72-1.72a.75.75 0 00-1.06 1.06l3 3z" 
          clip-rule="evenodd"
        />
        <path 
          d="M14.25 5.25a5.23 5.23 0 00-1.279-3.434 9.768 9.768 0 016.963 6.963A5.23 5.23 0 0016.5 7.5h-1.875a.375.375 0 01-.375-.375V5.25z"
        />
      </svg>
    </span>
    <span class="btn-text">Download CV</span>
  </a>
</template>

<script>
export default {
  name: 'ResumeButton',
  props: {
    resumePath: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
.resume-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  padding: 0.85rem 1.4rem;
  font-family: 'Space Grotesk', sans-serif;
  font-size: 0.92rem;
  font-weight: 800;
  letter-spacing: -0.01em;
  color: #121212;
  background-color: #FFE600;
  border: 2.5px solid #121212;
  border-radius: 14px;
  text-decoration: none;
  box-shadow: 4px 4px 0 #121212;
  transform: translate(0, 0);
  transition: all 0.12s cubic-bezier(0.16, 1, 0.3, 1);
  user-select: none;
  cursor: pointer;
}

.resume-button:hover {
  transform: translate(2px, 2px);
  box-shadow: 2px 2px 0 #121212;
}

.resume-button:active {
  transform: translate(4px, 4px);
  box-shadow: 0px 0px 0 #121212;
}

.icon-wrap {
  display: grid;
  place-items: center;
  width: 1.5rem;
  height: 1.5rem;
  background: #121212;
  color: #FFE600;
  border-radius: 6px;
}

.icon {
  width: 0.95rem;
  height: 0.95rem;
}

.btn-text {
  line-height: 1;
}

@media (max-width: 640px) {
  .resume-button {
    padding: 0.75rem 1rem;
    font-size: 0.85rem;
    border-radius: 12px;
  }
}
</style>
